import i18n from '@/i18n';
import { numberLocale } from '@/lib/locale';

export const formatUZS = (amount: number): string => {
  return new Intl.NumberFormat(numberLocale()).format(amount) + ' ' + i18n.t('misc_common.currency');
};
